import { ApplicationState } from '../..';

export const selectedHonoraryNote = (state: ApplicationState) => state.details.detailsHonoraryNote.selectedHonoraryNote;
